// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1B1Ag","footer":"Form_footer__Wd2qk"};